// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import type { CuiOptionType } from '@crehana/ui';

const orderOptions = (a: CuiOptionType<string>, b: CuiOptionType<string>) => {
  if (a.label < b.label) {
    return -1;
  }
  if (a.label > b.label) {
    return 1;
  }
  return 0;
};

export default orderOptions;
